import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HOME_HERO_IMAGE_HEIGHT_PX, HOME_HERO_RESTING_HEIGHT_PX } from '../../model/types/home-revamp-types';

@Component({
  selector: 'rmt-home-hero',
  templateUrl: 'rmt-home-hero.html'
})
export class RmtHomeHeroComponent {
  @Input() image: string = '';
  @Input() titleLead: string = '';
  @Input() titleCountry: string = '';
  @Input() subtitleHtml: string = '';
  @Input() initials: string = '';
  @Input() rewardLabel: string = '';
  @Input() pullOffset: number = 0;
  @Output() profileClick = new EventEmitter<void>();
  @Output() rewardClick = new EventEmitter<void>();
  @Output() termsClick = new EventEmitter<void>();

  get isPulling(): boolean {
    return this.pullOffset > 0;
  }

  get heroHeight(): string {
    return `${HOME_HERO_RESTING_HEIGHT_PX + this.pullOffset}px`;
  }

  get imageHeight(): string {
    return `${HOME_HERO_IMAGE_HEIGHT_PX + this.pullOffset}px`;
  }

  onSubtitleClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target && target.classList && target.classList.contains('home-hero__terms')) {
      event.preventDefault();
      this.termsClick.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-home-hero/rmt-home-hero.ts